/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityLikeDto } from '../../models/community-like-dto';

export interface CommunityLikeControllerUnLiked$Params {
  id: string;
}

export function communityLikeControllerUnLiked(http: HttpClient, rootUrl: string, params: CommunityLikeControllerUnLiked$Params, context?: HttpContext): Observable<StrictHttpResponse<CommunityLikeDto>> {
  const rb = new RequestBuilder(rootUrl, communityLikeControllerUnLiked.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommunityLikeDto>;
    })
  );
}

communityLikeControllerUnLiked.PATH = '/api/community-like/{id}';
